import * as types from '../types/categoryTypes';

const initialState = {
  loading: false,
  categories: [],
  popularCategories: [],
  category: null,
  categoryArticles: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  },
  error: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH CATEGORIES
    case types.FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        error: null,
      };
    case types.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH POPULAR CATEGORIES
    case types.FETCH_POPULAR_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_POPULAR_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        popularCategories: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        error: null,
      };
    case types.FETCH_POPULAR_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH CATEGORY BY SLUG
    case types.FETCH_CATEGORY_BY_SLUG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CATEGORY_BY_SLUG_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.payload.data || action.payload,
        error: null,
      };
    case types.FETCH_CATEGORY_BY_SLUG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH CATEGORY ARTICLES
    case types.FETCH_CATEGORY_ARTICLES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CATEGORY_ARTICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryArticles: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.FETCH_CATEGORY_ARTICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CREATE CATEGORY
    case types.CREATE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [...state.categories, action.payload.data || action.payload],
        error: null,
      };
    case types.CREATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UPDATE CATEGORY
    case types.UPDATE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_CATEGORY_SUCCESS:
      const updatedCategory = action.payload.data || action.payload;
      return {
        ...state,
        loading: false,
        categories: state.categories.map(category => 
          category._id === updatedCategory._id ? updatedCategory : category
        ),
        category: state.category?._id === updatedCategory._id ? updatedCategory : state.category,
        error: null,
      };
    case types.UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DELETE CATEGORY
    case types.DELETE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter(category => category._id !== action.payload),
        error: null,
      };
    case types.DELETE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default categoryReducer;


